import { useState } from 'react';

const PHOTOS = [
  {
    src: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20garden%20bench%20with%20ornate%20scrollwork%20and%20wooden%20seat%2C%20placed%20in%20flower%20garden%20with%20roses%2C%20sunny%20day%2C%20professional%20photography%2C%20elegant%20metalwork%20details%2C%20neutral%20soft%20background%2C%20harmonious%20composition&width=800&height=600&seq=benches-gallery-01&orientation=landscape',
    alt: 'Кованая садовая скамейка с деревянным сиденьем в саду',
    caption: 'Садовая скамейка с деревянным сиденьем',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Pair%20of%20wrought%20iron%20benches%20with%20decorative%20backrest%20in%20park%20setting%2C%20forged%20floral%20patterns%2C%20green%20lawn%20background%2C%20sunlight%2C%20professional%20outdoor%20photography%2C%20clean%20composition%2C%20elegant%20craftsmanship&width=800&height=600&seq=benches-gallery-02&orientation=landscape',
    alt: 'Две кованые скамейки с узорными спинками в парке',
    caption: 'Кованые скамейки в парке',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Long%20wrought%20iron%20bench%20with%20armrests%20and%20decorative%20legs%2C%20placed%20near%20brick%20wall%2C%20ivy%20background%2C%20vintage%20style%2C%20afternoon%20light%2C%20professional%20photography%2C%20warm%20tones%2C%20detailed%20metalwork&width=800&height=600&seq=benches-gallery-03&orientation=landscape',
    alt: 'Длинная кованая скамейка с подлокотниками у кирпичной стены',
    caption: 'Кованая скамейка у стены с плющом',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20bench%20with%20curved%20backrest%20and%20wooden%20slats%2C%20on%20stone%20patio%2C%20potted%20plants%20around%2C%20summer%20garden%20scene%2C%20professional%20photography%2C%20bright%20daylight%2C%20simple%20background&width=800&height=600&seq=benches-gallery-04&orientation=landscape',
    alt: 'Кованая скамейка с изогнутой спинкой на каменной террасе',
    caption: 'Скамейка с изогнутой спинкой',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Black%20wrought%20iron%20bench%20with%20golden%20accents%2C%20ornate%20forged%20pattern%2C%20luxury%20garden%20setting%2C%20evening%20ambient%20light%2C%20professional%20photography%2C%20elegant%20craftsmanship%2C%20neutral%20background&width=800&height=600&seq=benches-gallery-05&orientation=landscape',
    alt: 'Кованая скамейка с золотистыми акцентами в вечернем саду',
    caption: 'Элитная скамейка с декором',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Wrought%20iron%20bench%20in%20front%20of%20house%20entrance%2C%20decorative%20forged%20sides%2C%20wooden%20seat%2C%20cozy%20porch%20setting%2C%20morning%20light%2C%20professional%20photography%2C%20warm%20homely%20atmosphere%2C%20clean%20background&width=800&height=600&seq=benches-gallery-06&orientation=landscape',
    alt: 'Кованая скамейка у входа в дом с коваными боковинами',
    caption: 'Скамейка у входа в дом',
  },
];

export default function GallerySection() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const prev = () => setLightbox((p) => (p === null ? null : p === 0 ? PHOTOS.length - 1 : p - 1));
  const next = () => setLightbox((p) => (p === null ? null : p === PHOTOS.length - 1 ? 0 : p + 1));

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Наши работы
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Реальные скамейки, изготовленные нашей командой
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {PHOTOS.map((photo, idx) => (
            <div
              key={photo.src}
              className="relative overflow-hidden rounded-lg cursor-pointer group"
              style={{ aspectRatio: '4/3' }}
              onClick={() => setLightbox(idx)}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-background-50 text-xs font-medium">{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-chat-3-line text-base"></i>
            </span>
            Хочу такую же — обсудить проект
          </a>
        </div>
      </div>

      {lightbox !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm" onClick={() => setLightbox(null)}>
          <button onClick={(e) => { e.stopPropagation(); prev(); }} className="absolute left-4 md:left-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"><i className="ri-arrow-left-s-line text-xl"></i></button>
          <div className="relative max-w-4xl w-full mx-4 md:mx-16" onClick={(e) => e.stopPropagation()}>
            <img src={PHOTOS[lightbox].src} alt={PHOTOS[lightbox].alt} className="w-full max-h-[80vh] object-contain rounded-lg" />
            <p className="text-background-50/80 text-sm text-center mt-3">{PHOTOS[lightbox].caption}</p>
            <span className="absolute top-3 right-3 text-background-50/60 text-xs">{lightbox + 1} / {PHOTOS.length}</span>
          </div>
          <button onClick={(e) => { e.stopPropagation(); next(); }} className="absolute right-4 md:right-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"><i className="ri-arrow-right-s-line text-xl"></i></button>
          <button onClick={() => setLightbox(null)} className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"><i className="ri-close-line text-lg"></i></button>
        </div>
      )}
    </section>
  );
}